import type { ReactNode } from "react";
import Image from "./Image";

interface Project {
    name: string;
    logo: string;
    href: string;
    domain: string;
    context: string;
    description: ReactNode;
}

const projects: Project[] = [
    {
        name: "ITDANA",
        logo: "/itdana.png",
        href: "https://itdana.de",
        domain: "itdana.de",
        context: "IT-Designers GmbH",
        description: (
            <>
                ITDANA ist eine KI Plattform für die Prozessautomatisierung und Datenanalyse in mittelständischen Unternehmen und Konzernen. Sie kommt überall dort zum Einsatz, wo Geschäftsprozesse digital abgebildet, durch Datenanalyse unterstützt und automatisiert werden sollen.
                <br />
                <br />
                Die Plattform ist Kubernetes basiert und erfüllt hohe Anforderungen an Skalierbarkeit, Verfügbarkeit und Individualisierbarkeit.
            </>
        ),
    },
    {
        name: "infiSTAR Vision",
        logo: "/infistar.png",
        href: "https://infistar.de",
        domain: "infistar.de",
        context: "Privat",
        description: (
            <>
                infiSTAR ist eine Software für die Verwaltung von Servern und Communities für die Spielereihe ArmA. Sie bietet umfangreiche Funktionen für die Administration, Moderation und Interaktion mit Spielern, um ein reibungsloses und sicheres Spielerlebnis zu gewährleisten.
                <br />
                <br />
                Mit infiSTAR Vision wurde eine Cloud-Schnittstelle für die Fernverwaltung von ArmA-Servern entwickelt, die es ermöglicht, Server von überall aus zu überwachen und zu steuern.
            </>
        ),
    },
];

export default function Projects() {
    return (
        <section id="projects" className="card">
            <h2 className="card__title">Meine Projekte</h2>
            <p className="card__text">
                Eine Auswahl von Projekten aus meiner Zeit als Full-Stack-Entwickler und meinem
                aktuellen beruflichen Umfeld.
            </p>
            <ul className="projects">
                {projects.map((project) => (
                    <li key={project.href}>
                        <a
                            className="project"
                            href={project.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Image
                                className="project__logo"
                                src={project.logo}
                                alt={`${project.name} Logo`}
                                width={56}
                                height={56}
                                loading="lazy"
                                decoding="async"
                            />
                            <div className="project__info">
                                <h3 className="project__name">{project.name}</h3>
                                <p className="project__context">{project.context}</p>
                                <p className="project__description">{project.description}</p>
                                <span className="project__url">
                                    {project.domain}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path d="M14 4h6v6" />
                                        <path d="M20 4 10 14" />
                                        <path d="M19 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6" />
                                    </svg>
                                </span>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
}
